const log = {
    invalid_type: 'El tipo de registro es inválido.',
    invalid_time_window: '`end_time` debe ser posterior a `start_time`.',
};
export default Object.freeze(log);
